module.exports = __webpack_public_path__ + "images/category_lp/hobby/assessment_achievements/4@2x_f68d3c8b6712b00a895f1f989d2b58de.png";